import React, { useCallback } from "react";

import { ReferencePickerPlugin } from "@adsk/acc-reference-picker";
import { LinkButton } from "@adsk/alloy-react-button";
import EmptyState from "@adsk/alloy-react-empty-state";
import { useLocale } from "@adsk/alloy-react-locale";

import { SystemWithCategoryAndStatus } from "../../models";
import { useSearch } from "../shared/SearchContext";

const SystemsPickerNoSearchResults: ReferencePickerPlugin<SystemWithCategoryAndStatus>["CustomPickerNoSearchResults"] =
  ({ clearFilters }) => {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
    const { setSearchTerm } = useSearch();

    const onClick = useCallback(() => {
      setSearchTerm("");
      clearFilters();
    }, [setSearchTerm, clearFilters]);

    return (
      <EmptyState
        illustrationType={EmptyState.ILLUSTRATION_TYPES.SEARCH_GREY}
        title={T.translate("NO_SEARCH_RESULTS_TITLE")}
        description={T.translate("NO_SEARCH_RESULTS_DESCRIPTION")}
      >
        <LinkButton onClick={onClick}>{T.translate("CLEAR_SEARCH")}</LinkButton>
      </EmptyState>
    );
  };

export default SystemsPickerNoSearchResults;
